export const legacyStorageCleanupOffices = [{ id: 'mock-office', name: 'Mock 업로드지점' }]
export const legacyStorageCleanupRows = Array.from({ length: 4 }, (_, index) => ({
  id: `MOCK-FILE-${index + 1}`, no: index + 1, office: 'Mock 지점', customerNo: `MOCK-${index + 1}`, oldNo: '-', baby: '아기◯',
  mother: '보호자◯', motherPhone: '010-0000-0000', father: '보호자◯', fatherPhone: '010-0000-0000', usage: ['촬영원본','후기','편집본','고객선택사진'][index],
  size: `${12 + index}.00`, count: 2 + index, uploadedAt: '0000-00-00 00:00', downloadedAt: '-',
}))
